<template>
  <div>
    <form-section
      :title="$t('ApplicationForm_Row_iOSPushNotificationSettingsTitle')"
      :description="$t('ApplicationForm_Row_IosSettingsInfo')"
    >
      <el-row>
        <el-col :span="12">
          <rest-form-item
            prop="ios_url"
            :label="$t('ApplicationForm_Field_UrlLink')"
          >
            <el-input v-model="model.ios_url" />
          </rest-form-item>
        </el-col>
        <el-col :span="12">
          <rest-form-item
            prop="ios_bundle_id"
            :label="$t('ApplicationForm_Field_IosBundleId')"
          >
            <el-input v-model="model.ios_bundle_id" />
          </rest-form-item>
        </el-col>
      </el-row>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
export default {
  name: 'ApplicationIosFormPage',
  components: { RestFormItem, FormSection },
  props: {
    model: {
      required: true,
      type: Object
    },
    readonly: {
      required: true,
      type: Boolean
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/account/components/ApplicationIosFormPage.vue